// extracted by mini-css-extract-plugin
export var avatar = "_rn-3";
export var avatarContainer = "_rn-2";
export var avatarSpacer = "_rn-5";
export var avatarSpacerContainer = "_rn-4";
export var avatarStackContainer = "_rn-1";
export var bubble = "_rn-0";
export var remainderBubble = "_rn-6";